// extracted by mini-css-extract-plugin
module.exports = {"Selection":"Selection_Selection__1sI0p","EditDeleteButtons":"Selection_EditDeleteButtons__1VuwK","LockIn":"Selection_LockIn__1twZG","Overlay":"Selection_Overlay__8154U"};